/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Computer_Science26Inputs */

const en__field_enum_csjensblank_computer_science26 = /** @type {(inputs: _Field_Enum_Csjensblank_Computer_Science26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer Science`)
};

const de__field_enum_csjensblank_computer_science26 = /** @type {(inputs: _Field_Enum_Csjensblank_Computer_Science26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informatik`)
};

/**
* | output |
* | --- |
* | "Computer Science" |
*
* @param {_Field_Enum_Csjensblank_Computer_Science26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_computer_science26 = /** @type {((inputs?: _Field_Enum_Csjensblank_Computer_Science26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Computer_Science26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_computer_science26(inputs)
	return de__field_enum_csjensblank_computer_science26(inputs)
});
export { _field_enum_csjensblank_computer_science26 as "_field_enum_CSJENSBLANK_COMPUTER_SCIENCE" }